export const KEEP_SHARE_LINK = 'KEEP_SHARE_LINK'
// export const SET_SHARE_CONFIG = 'SET_SHARE_CONFIG'
export const UPDATE_CURRENT_CONFIG = 'UPDATE_CURRENT_SHARE_CONFIG'
export const SET_PREVIOUS_STATE = 'SET_PREVIOUS_STATE_SHARE'
export const SET_INITIALIZED = 'SET_INITIALIZED_SHARE'
// export const SET_FILE_SHARE_CONFIG = 'SET_FILE_SHARE_CONFIG'
